<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!-- content-header component -->
    <app-content-header [contentHeader]="contentHeader"></app-content-header>

    <section id="faq-search-filter">
      <div class="card faq-search" style="background-image: url('assets/images/banner/banner.png')">
        <div class="card-body text-center">
          <!-- main title -->
          <h2 class="text-primary">{{topic.title}}</h2>

          <!-- subtitle -->
          <p class="card-text mb-2">{{ topic.subtitle }}</p>

        </div>
      </div>
    </section>
    <!-- account setting page -->
    <section id="returns-warranties">
      <div class="row nav-vertical justify-content-center">
        <div class="col-md-12 col-lg-10 col-xl-8 mb-2 mb-md-0">
          <!-- payment panel -->
          <div
            role="tabpanel"
            class="tab-pane active collapse-icon"
            id="faq-payment"
            aria-labelledby="payment"
            aria-expanded="true"
          >

            <!-- frequent answer and question  collapse  -->
            <div class="">

              <div class="card bg-danger bg-darken-1 text-white mb-1">
                <div class="card-body">
                  <h5 class="card-title text-white pt-50 mb-25">Attenzione!</h5>
                  <p class="card-text">Le ricordiamo che verranno accettate richieste di resi solo entro 15gg di calendario dalla data dell’ordine.

                    Si avvisa che qualora il materiale reso riporti scritte di qualsiasi tipo, o confezioni danneggiate e quindi non rivendibile, lo stesso sarà restituito.</p>
                </div>
              </div>
              <div class="card mb-1"
                   *ngFor="let question of topic.qanda; let i = index"
              >
                <div class="card-header">
                  <h3 class="card-title text-primary px-50"><i class="icon-medium mr-1" [data-feather]="question.icon"></i> <span>{{question.question}}</span></h3>
                </div>
                <div class="card-content">
                  <div class="card-body px-3 pb-2 pt-1">
                    <div [innerHTML]="question.answer"></div>
                    <ngb-alert *ngIf="question.alert" [type]="question.alert.type" [dismissible]="false">
                      <div class="alert-body" [innerHTML]="question.alert.message"></div>
                    </ngb-alert>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--/ account setting page -->

    <!-- contact us -->
    <section class="faq-contact">
      <div class="row mt-5 pt-75">
        <div class="col-12 text-center">
          <h2>Hai ancora delle domande?</h2>
          <p class="mb-3">
            Se non hai trovato la risposta che cercavi, contattaci e saremo lieti di aiutarti.
          </p>
        </div>
        <div class="col-sm-6">
          <a href="tel:+3901119510050" class="card text-center faq-contact-card shadow-none py-1">
            <div class="card-body">
              <div class="avatar avatar-tag bg-light-primary mb-2 mx-auto">
                <i data-feather="phone-call" class="font-medium-3"></i>
              </div>
              <h4>+ (39) 011 19510050</h4>
              <span class="text-body">Siamo felici di esserti utili!</span>
            </div>
          </a>
        </div>
        <div class="col-sm-6">
          <a href="mailto:support@tulero.it" class="card text-center faq-contact-card shadow-none py-1">
            <div class="card-body">
              <div class="avatar avatar-tag bg-light-primary mb-2 mx-auto">
                <i data-feather="mail" class="font-medium-3"></i>
              </div>
              <h4>support@tulero.it</h4>
              <span class="text-body">Se cerchi una risposta celere!</span>
            </div>
          </a>
        </div>
      </div>
    </section>
    <!--/ contact us -->
  </div>
</div>
